import { combineReducers } from 'redux';

import { ApiReducerKey } from 'constants/index';

import download from './download';
import select from './select';

export default combineReducers({ [ApiReducerKey.DOWNLOAD]: download, select });
